import React from "react";
import "../../pages/style.css";
import { Container, Row, Col } from "react-bootstrap";
import Text from "../Homepage/Text";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

const Home = () => {
  return (
    <div className="homepagebackground">
      <Container>
        <Row>
          <Col md={5}>
            <div className="imagedeveloper"></div>
          </Col>
          <Col md={7}>
            <h1 className="headtext">
              Hey All<span className="wave">👋 </span>
            </h1>
            <h2 className="nametext">I&apos;m Nafees </h2>
            <button
              onClick={() => {
                window.open("https://github.com/Chiksinafees");
              }}
              className="socailmediabtn"
            >
              <AiFillGithub className="icon" />
            </button>
            <button
              onClick={() => {
                window.open("https://www.linkedin.com/feed/");
              }}
              className="socailmediabtn1"
            >
              <FaLinkedinIn className="icon" />
            </button>
            <button
              onClick={() => {
                window.open("https://twitter.com/Chiksinafees");
              }}
              className="socailmediabtn2"
            >
              <AiOutlineTwitter className="icon" />
            </button>
            <button
              onClick={() => {
                window.open("https://www.instagram.com/nafees_chiksi/");
              }}
              className="socailmediabtn3"
            >
              <AiFillInstagram className="icon" />
            </button>
            <Text />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Home;
